export const isNumber = (num) =>
  !!(typeof num === 'number') && !Number.isNaN(num);

export default {
  isNumber,
};
